import React from 'react';
import { motion } from 'framer-motion';
import { useAiCommandPalette } from '../context/AiCommandPaletteContext';

const ErrorMessage = () => {
  const { error } = useAiCommandPalette();

  if (!error) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="p-4 text-red-600 dark:text-red-400 text-sm flex items-center gap-2 text-center w-full"
    >
      <div className="rounded-lg bg-red-500/10 border border-red-500/20 p-3 w-full">
        {error}
      </div>
    </motion.div>
  );
};

export default ErrorMessage; 